module.exports = __webpack_public_path__ + "img/img2.e9179d91.jpg";